(function($, document)   {
    "use strict";
    $(function()    {
        var idx = 0;
        $(document).on('click', '.projects .load-more a', function()  {
            var $me = $(this);
            $me.addClass('loading');
            var url = 'projects/entries/P' + idx;
            $.get(
                url
            ).done(function(res)   {
                console.log('here done');
                $('.load-more').hide();
                var $res = $($(res).find('#post-container').html());
                console.log($res);
                $res.hide();
                $('.js-project:last').after($res);
                $res.slideDown(500);
                idx+=3;
            }).always(function()    {
                $me.removeClass('loading');
            });
            return false;
        });
    });
})(jQuery, document);
$(document).ready(function(){

    $(".div_link").click(function(){
      window.location=$(this).find("a").attr("href"); return false;
    });

});
/*
$(document).ready(function () {
    $('.hide').fadeIn(1000).removeClass('hide');
});
*/
